import { useCallback } from 'react';

const useIsExistingCompany = fields => {
  const isExistingCompany = useCallback(() => {
    if (fields.companyName == null || fields.companyName === '') return false;

    return fields.companyName.value !== 0;
  }, [fields.companyName]);

  return { isExistingCompany };
};

export default useIsExistingCompany;
